import styled from 'styled-components';

export const Client = styled.div`
  font-family: Poppins, Heltica, Arial, sans-serif;
  
  .page-container .container-button {
    margin: 0 40px;
    
    button {
      font-size: 2em;
    }
  }

  .content-welcome > h2 {
     font-size: 2.1em;
     padding-left: 43px;
  }
  
  .table-list {
    background-color: #FFF;
    padding: 45px;
    margin: 45px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, .2);
    border-radius: 4px;
    
    h2.title-form {
      font-size: 1.6em;
    }
    
    .input-txt {
      font-size: 1.4em;
    }
  }
  
  h3 {
    color: #A2A2A2;
    font-size: 1.5em;
  }
  
  input {
    color: #2B2932;
  }
`;
